// extracted by mini-css-extract-plugin
export var container = "_rq-0";
export var table = "_rq-2";
export var tableWrapper = "_rq-1";